// extracted by mini-css-extract-plugin
export var body = "Chapter-module--body--ad1dc";
export var bodyText = "Chapter-module--body-text--5b25f";
export var eyebrow = "Chapter-module--eyebrow--e10ae";
export var header = "Chapter-module--header--e38a9";
export var headerActions = "Chapter-module--header-actions--b6107";
export var headerCopy = "Chapter-module--header-copy--92f49";
export var intro = "Chapter-module--intro--530a2";
export var next = "Chapter-module--next--b6c42";
export var pagination = "Chapter-module--pagination--0def3";
export var paginationIntro = "Chapter-module--pagination-intro--70180";
export var paginationLabel = "Chapter-module--pagination-label--a87f5";
export var paginationTitle = "Chapter-module--pagination-title--3ed5d";
export var previous = "Chapter-module--previous--10ec5";
export var title = "Chapter-module--title--15b72";
export var tocContainer = "Chapter-module--toc-container--0455d";
export var tocInner = "Chapter-module--toc-inner--9b182";